module.exports = __webpack_public_path__ + "img/dbcpfw_01.523ade41.jpg";